export default __webpack_public_path__ + "static/media/residual.aaa9b849.svg";